export default __webpack_public_path__ + "static/rotating-background-e696912e61c50342aec5ed0e19ee4a73.mp4";